import { render, staticRenderFns } from "./CotizaComoAgente.vue?vue&type=template&id=6319c198&scoped=true"
import script from "./CotizaComoAgente.vue?vue&type=script&lang=js"
export * from "./CotizaComoAgente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6319c198",
  null
  
)

export default component.exports